<template>
    <div class="myform">
        
        <!-- <div class="form-list">
            <div class="label">类型</div>
            <div class="val-content" @click="dPopupShow=true">
                <nut-textinput class="input" v-model="this.list_show_type_text" placeholder="请选择类型" :clearBtn="false" :disabled="true" :has-border="false"/>
                <img src="../assets/images/icon_right.png" alt="">
            </div>
            <div class="error-prompt" v-if="error.list_show_type">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请选择正确驾校类型</span>
            </div>
        </div> -->
        <div class="form-list">
            <div class="label">驾校全称</div>
            <div class="val-content">
                <nut-textinput class="input" v-model="formData.full_name" placeholder="请填写营业执照上的公司名称" :clearBtn="false" :disabled="false" :has-border="false"/>
            </div>
            <div class="error-prompt" v-if="error.full_name">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请输入驾校全称</span>
            </div>
        </div>
        <div class="form-list">
            <div class="label">驾校简称</div>
            <div class="val-content">
                <nut-textinput class="input" v-model="formData.store_name" placeholder="驾校品牌+驾校名称" :clearBtn="false" :disabled="false" :has-border="false"/>
            </div>
            <div class="error-prompt" v-if="error.store_name">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请输入驾校简称</span>
            </div>
        </div>
        <div class="form-list">
            <div class="label">地址</div>
            <div class="val-content">
                <nut-textinput class="input" v-model="formData.address" placeholder="请输入地址" :clearBtn="false" :has-border="false"/>
                <!-- <img src="../assets/images/icon_right.png" @click="showAddrPopup=true" alt=""> -->
            </div>
            <div class="error-prompt" v-if="error.address">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请输入正确的地址</span>
            </div>
        </div>
        <div class="form-list">
            <div class="label">姓名</div>
            <div class="val-content">
                <nut-textinput class="input" v-model="formData.store_username" placeholder="请输入负责人姓名" :clearBtn="false" :disabled="false" :has-border="false"/>
            </div>
            <div class="error-prompt" v-if="error.store_username">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请输入负责人姓名</span>
            </div>
        </div>
        <div class="form-list">
            <div class="label">手机号码</div>
            <div class="val-content">
                <nut-textinput class="input" maxlength="11" v-model="formData.phone" placeholder="此手机号用于个人账号登录" :clearBtn="false" :disabled="false" :has-border="false"/>
            </div>
            <div class="error-prompt" v-if="error.phone">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请输入正确的手机号码</span>
            </div>
        </div>
        <div class="form-list">
            <div class="label">验证码</div>
            <div class="val-content">
                <nut-textinput class="input" maxlength="6" v-model="formData.mobile_code" placeholder="请输入验证码" :clearBtn="false" :disabled="false" :has-border="false"/>
                <span @click="getCode">{{ getCodeText }}</span>
            </div>
            <div class="error-prompt" v-if="error.mobile_code">
                <img src="../assets/images/icon_danger.png" alt="">
                <span>请输入正确的验证码</span>
            </div>
        </div>
        <!-- 选择类型弹窗 -->
        <nut-picker
            :is-visible="dPopupShow"
            title="选择驾校类型"
            :list-data="listData"
            @confirm="chooseType"
            @close="closeType"
        >
        </nut-picker>

        <nut-address
            v-model="showAddrPopup"
            :province="addr.province"
            :city="addr.city"
            :country="addr.country"
            :town="addr.town"
            customAddressTitle="请选择所在地区"
            @onChange="onChangeAddr"
            @close="closeAddr"
            :default-value-data="defaultValueData"
        >
        </nut-address>
    </div>
</template>

<script>
import cache from "../utils/cache"

var regionAll = [];
export default {
    name: 'EnterForm',
    components: {},
    data() {
        return {
            showAddrPopup: false,
            addr: {
                province: [{id: 1, name: '北京'}],
                city: [{id: 1, name: '北京'}],
                country: [{id: 1, name: '北京'}],
                town:[{id:1,name:'北京'}]
            },
            address:'',
            list_show_type_text:'',
            getCodeText: '获取验证码',
            //表单数据
            formData: {
                province_id:'',
                city_id:'',
                district:'',
                street_id:'',
                province_name:'',
                city_name:'',
                district_name:'',
                street_name:'',
                // list_show_type:'',
                full_name:'',
                store_name:'',
                store_username:'',
                phone: '',
                mobile_code: '',
                address:''
            },
            //表单数据
            error: {
                full_name:false,
                store_name:false,
                store_username:false,
                phone: false,
                mobile_code: false,
                address:false,
            },
            dPopupShow: false, //显示选择驾照弹窗
            listData: [
                [{label: 1, value: '总校'}, {label: 2, value: '分校'}],
            ],
            defaultValueData:null,
        }
    },
    created() {
        //this.temp();
        this.getRecord();
        // this.getRegionAll(()=> {
        //     this.getRegion(0, province => {
        //         this.addr.province = province;
        //         this.getRegion(province[0].id, city => {
        //             this.addr.city = city;
        //             this.getRegion(city[0].id, country => {
        //                 this.addr.country = country;
        //                 this.getRegion(country[0].id, town => {
        //                     this.addr.town = town;
        //                 })
        //             })
        //         })
        //     })
        // })
       
    },
    methods: {
        getRegionAll(call){
            let data = cache.get('RegionAll');
            if(data){
                regionAll = JSON.parse(data);
                call();
            }else{
                this.$ajax.get('m/system/get_region', {
                    all: 1
                }).then(res => {
                    regionAll = res ;
                    cache.set('RegionAll',JSON.stringify(res),38640);
                    call();
                })
            }
        },
        getRecord(){

          this.$ajax.get('m/trade/ruzhu', {
                activity_id: this.$ajax.get_activity_id(),
            }).then(res => {
                if(res.store_info){
                    this.formData.province_id = res.store_info.province_id;
                    this.formData.city_id = res.store_info.city_id;
                    this.formData.district = res.store_info.district;
                    this.formData.street_id = res.store_info.street_id;
                    this.formData.address = res.store_info.store_address;
                    this.formData.city_name = res.store_info.city_name;
                    this.formData.district_name = res.store_info.district_name;
                    this.formData.street_name = res.store_info.street_name;
                    // this.formData.list_show_type = res.store_info.list_show_type;
                    this.formData.full_name = res.store_info.full_name;
                    this.formData.store_name = res.store_info.store_name;
                    this.formData.store_username = res.store_info.store_username;
                    this.formData.phone = res.store_info.store_phone;
                    //this.list_show_type_text = res.store_info.list_show_type == 1 ? '总校' : '分校';
                    this.list_show_type_text = res.store_info.list_show_type == 2 ? '分校' : '总校';
                    //this.address = res.show_address;
                    //this.address = '请选择地区';
                }
                 
            })
        },
        getRegion(parent_id, call) {
            let ret = [] ;
            for(let i = 0 , len = regionAll.length ; i<len ; i++){
                if(parseInt(regionAll[i].parent_id)===parseInt(parent_id)){
                    ret.push(regionAll[i]);
                }
            }
            call(ret);

            // this.$ajax.get('m/system/get_region', {
            //     parent_id: parent_id
            // }).then(res => {
            //     call(res);
            // })
        },
        // 选择驾校类型
        chooseType(value) {
            this.formData.list_show_type = value[0].label;
            this.list_show_type_text = value[0].value;
            this.dPopupShow = false;
        },
        closeType() {
            this.dPopupShow = false
        },
        getCode() {
            if (this.getCodeText !== '获取验证码') return;
            const phone = this.formData.phone;
            if(!phone){
                this.$toast.text('请填写手机号~');return;
            }
            var reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
            if (!reg.test(phone)) {
                this.$toast.text('请输入正确的手机号格式~');return;
            }
            this.$ajax.get('m/user/send_sms_code', {
                phone: this.formData.phone,
                Ot:8,
            }).then(res => {
                let timer, time = 60;
                timer = setInterval(() => {
                    if (time <= 0) {
                        this.getCodeText = '获取验证码';
                        clearInterval(timer);
                    }else{
                        this.getCodeText = time-- + 's';
                    }
                }, 1000)
            })
        },
        onChangeAddr(e) {
            //if (e.next === 'town') {
                //this.showAddrPopup = false;
            //} else {
                this.getRegion(e.value.id, res => {

                    if (res.length == 0) {
                        this.showAddrPopup = false;
                    } else {
                        this.addr[e.next] = res;
                    }
                })
            //}
        },
        closeAddr(e) {
            this.formData.province_id = e.data.province.id;
            this.formData.city_id = e.data.city.id;
            this.formData.district = e.data.country.id;
            this.formData.street_id = e.data.town.id;
            this.formData.province_name = e.data.province.name;
            this.formData.city_name = e.data.city.name;
            this.formData.district_name = e.data.country.name;
            this.formData.street_name = e.data.town.name;

            if (e.data.town.name === undefined) {
                this.address = e.data.province.name+e.data.city.name+e.data.country.name;
            } else {
                this.address = e.data.province.name+e.data.city.name+e.data.country.name+e.data.town.name;
            }
        },
        submit() {

          var hasError = false;
            for (let key in this.formData) {
                for (let key2 in this.error) {
                
                    if(this.error[key] !== false && key2 == key){
                        this.error[key] = !this.formData[key];
                        hasError = true;
                    }
                }
            }
            if(hasError == false){
                this.$ajax.post('m/trade/ruzhu', {
                    mobile_code : this.formData.mobile_code,
                    phone:this.formData.phone,
                    province_name:this.formData.address,
                    city_name:this.formData.city_name,
                    district_name:this.formData.district_name,
                    street_name:this.formData.street_name,
                    province_id:this.formData.province_id,
                    city_id:this.formData.city_id,
                    district:this.formData.district,
                    street_id:this.formData.street_id,
                    list_show_type:this.formData.list_show_type,
                    full_name:this.formData.full_name,
                    store_name:this.formData.store_name,
                    store_username:this.formData.store_username,
                    activity_id:this.$ajax.get_activity_id(),
                }).then((res) => {
                    this.$toast.text('提交成功平台将会与您联系');
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 2000);
                   
                })
            }
        },

        temp(){
            var geolocation = new qq.maps.Geolocation("4UXBZ-LS6KP-SMJDG-LMJTR-7XA4F-7BB4I","studycar");
            var options = {timeout:9000};
            var latitude;
            var longitude;
            var geocoder;
            var latLng
            geolocation.getLocation(showPosition,null,options);
            var that = this;

            function showPosition(position) {
                latitude = position.lat
                longitude = position.lng
                geocoder = new qq.maps.Geocoder();
                latLng = new qq.maps.LatLng(latitude,longitude);
                //经纬度解析
                geocoder.getAddress(latLng);
                //设置服务请求成功回调函数
                geocoder.setComplete(function(rs){
                var rsJson = JSON.parse(JSON.stringify(rs));
                var address = {};
                address.province = rsJson.detail.addressComponents.province;
                address.city = rsJson.detail.addressComponents.city;
                address.district = rsJson.detail.addressComponents.district;
                address.street = rsJson.detail.addressComponents.town + rsJson.detail.addressComponents.street;
                address.longitude = longitude;
                address.latitude = latitude;
                address.addr = address.province + (address.city == address.province ? '' : address.city) + address.district + address.street;
                console.log(address.addr)
                if(address.addr.length > 0){
                    that.address = address.addr;
                    that.formData.address = address.addr;
                    that.formData.in_car_longitude = address.longitude;
                    that.formData.in_car_latitude = address.latitude;
                }
                });
                geocoder.setError(function () {

                })
            }

            }
    },
}
</script>

<style lang="less" scoped>
    .myform {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        .form-list {
            width: 100%;
            height: 82px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;
            padding-top: 15px;
            .label {
                font-size: 14px;
                color: #333;
            }
            .val-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px #E2E2E2 solid;
                .input {
                    font-size: 13px;
                    flex: 1;
                }
                span {
                    font-size: 14px;
                    color: #3C43EC;
                }
            }
            .error-prompt {
                width: 100%;
                display: flex;
                align-items: center;
                span {
                    font-size: 12px;
                    color: #EB273B;
                    margin-left: 5px;
                }
            }
        }
    }

    /deep/ .nut-textinput-disabled input {
        background-color: #fff;
        color: #333;
    }
    /deep/ .nut-textinput input {
        height: 30px;
        padding: 0;
    }
</style>
